import React, { useState } from 'react';

import { Alert, Snackbar } from '@mui/material';

export default function Notification({
  showStatuses = [],
  handleClose = () => {},
}) {
  return (
    <>
      {showStatuses?.map((showStatus, index) => (
        <Snackbar
          key={index}
          open={showStatus?.show}
          autoHideDuration={6000}
          onClose={handleClose}
          // anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          sx={{ bottom: `${8 + index * 60}px` }}
        >
          <Alert
            variant='filled'
            severity={showStatus?.severity}
            onClose={handleClose}
            sx={{ width: '100%' }}
          >
            {showStatus?.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}

export const SEVERITY_OPTIONS = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error',
});

export const useNotification = () => {
  const [showStatuses, setShowStatus] = useState([]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setShowStatus([]);
  };

  const showNotifications = (notifications = []) => {
    setShowStatus(notifications);
  };

  return [showStatuses, showNotifications, handleClose];
};
